const getLocalStorageAccessor = key => ({
    set: value => { localStorage.setItem(key, value); },
    get: defaultValue => localStorage.getItem(key) || defaultValue,
    clear: () => { localStorage.removeItem(key); },
    isSet: () => !!localStorage.getItem(key)
});

const environment = process.env.AL_ENV || 'prod';
export const authTokenAccessor = getLocalStorageAccessor(`al.${environment}.authToken`);
